// src/features/counter/counterSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// hooks
import {
  doc,
  getDoc,
  Timestamp,
  addDoc,
  collection,
  getDocs,
  where,
  query,
} from 'firebase/firestore';
//
import { db } from 'src/auth/context/jwt/firebase';

const initialState = {
  value: null,
  recentGameHistory: [],
  loading: false,
  error: null,
};

export const statisticSlice = createSlice({
  name: 'statistic',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatistic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStatistic.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getStatistic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const getStatistic = createAsyncThunk('statistic/getStatistic', async ({ uid }) => {
  const statsRef = doc(db, 'users', uid);
  const snap = await getDoc(statsRef);

  if (snap.exists()) {
    // return snap.data().stats; // ✅ this must be serializable
    const data = snap.data().stats;

    const serializedStats = {
      ...data,
      lastWin:
        data.lastWin instanceof Timestamp ? data.lastWin.toDate().toISOString() : data.lastWin,
    };

    return serializedStats;
  }
  return null;
  // throw new Error('Stats not found');
});

// export const {} = statisticSlice.actions;
export default statisticSlice.reducer;
